import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';
import InvoicePreviewPopup from './components/InvoicePreviewPopup';

import Table from '../../components/ui/Table';
import {contractorsTableConfig} from './configs/contractorsTableConfig';

const PendingInvoicesPage = ({
    data,
    userData,
    filterContractorInvoices,
    tableType,
    paginationMetadata,
    onPageNumberChange,
    tableLoading
}) => {
    const [itemSelected, setItemSelected] = useState(null);
    const [showInvoicePreviewPopup, setShowInvoicePreviewPopup] = useState(false);

    useEffect(() => {
        if (!showInvoicePreviewPopup) {
            setItemSelected(null);
        }
    }, [showInvoicePreviewPopup]);

    const handleInvoicePreview = (item) => {
        setItemSelected(item);
        setShowInvoicePreviewPopup(true);
    }

    const displayedSection = "Factures fournisseurs en attente";
    const tableConfig = contractorsTableConfig({
        displayedSection,
        handleInvoicePreview,
        userData,
        filterContractorInvoices,
        tableType
    });

    return (
        <>
            <div className='flex items-center justify-between pt-10 pb-5'>
                <Link to='/dashboard/admin'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Factures fournisseurs en attente (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>
            <Table
                data={data}
                tableConfig={tableConfig}
                paginationMetadata={paginationMetadata}
                onPageNumberChange={onPageNumberChange}
                loading={tableLoading}
            />

            <InvoicePreviewPopup
                view={showInvoicePreviewPopup}
                setView={setShowInvoicePreviewPopup}
                item={itemSelected}
                type='contractor-invoice'
            />
        </>
    )
}

export default PendingInvoicesPage;
